exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page {\n  display: flex;\n  flex-direction: column;\n  height: 100%; }\n  .page > .toolbar {\n    flex: 0 1 auto; }\n  .page > .page-content {\n    flex: 1 1 100%;\n    overflow: auto; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/component/base-page/style.scss
// module id = 810
// module chunks = 0